import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Wheelchair = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 100 100"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.77 75.42a13.883 13.883 0 0 1-7.941 2.487c-7.706 0-13.954-6.248-13.954-13.954 0-2.952.922-5.686 2.487-7.94l-5.348-5.348a21.555 21.555 0 0 0-4.852 13.639c0 11.967 9.701 21.668 21.667 21.668 5.174 0 9.923-1.816 13.649-4.843L51.77 75.42z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.862,
    cy: 21.181,
    r: 7.152
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.35 45.582H57.609l8.977-8.978c.271-.215.515-.458.73-.729l.073-.073-.007-.007a4.448 4.448 0 0 0 .919-2.694 4.47 4.47 0 0 0-2.159-3.819l.001-.001L46.04 17.675l-.017.03a4.454 4.454 0 0 0-1.843-.405 4.456 4.456 0 0 0-2.986 1.16l-.006-.006-.06.06c-.077.072-.15.145-.222.222l-8.865 8.865.008.008a4.463 4.463 0 0 0-1.237 3.08 4.486 4.486 0 0 0 4.487 4.487 4.463 4.463 0 0 0 3.08-1.237l.008.008.081-.081.008-.008 6.457-6.457 5.514 3.184-13.011 13.012a21.568 21.568 0 0 0-6.854 3.582l5.307 5.307a13.882 13.882 0 0 1 7.94-2.487c7.707 0 13.954 6.248 13.954 13.954 0 2.952-.922 5.686-2.487 7.94l5.666 5.667a21.57 21.57 0 0 0 4.534-13.256c0-3.507-.838-6.816-2.317-9.746h5.683v18.371a4.488 4.488 0 1 0 8.976 0v-22.86a4.488 4.488 0 0 0-4.488-4.487z"
  }));
});
Wheelchair.displayName = 'Wheelchair';
export var WheelchairDimensions = {
  height: 100,
  width: 100
};